import React, { useState } from 'react';
import { Card, Row, Col } from 'antd';
import {
  FileTextOutlined,
  FileDoneOutlined,
  DollarOutlined,
  FundOutlined,
  ToolOutlined,
  ClusterOutlined,
} from '@ant-design/icons';
import ViewServices from '../../components/Manage/Services/ViewServices';
import ViewServiceType from '../../components/Manage/ServiceType/ViewServiceType';

const iconMap = {
  FileTextOutlined,
  FileDoneOutlined,
  DollarOutlined,
  FundOutlined,
  ToolOutlined,
  ClusterOutlined,
};

const ManageServices = ({ singleColumn = false }) => {
  const [selected, setSelected] = useState('Services');

  const manageServices = [
    {
      title: 'Services',
      compo: <ViewServices />,
      icon: 'ToolOutlined',
      color: '#1890ff',
      fontSize: 32,
    },
    {
      title: 'Service type',
      compo: <ViewServiceType />,
      icon: 'ClusterOutlined',
      color: '#722ed1',
      fontSize: 32,
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      {/* Cards like tabs */}
      <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
        {manageServices.map((item, index) => {
          const IconComponent = iconMap[item.icon];
          const isActive = selected === item.title;

          return (
            <Col
              key={index}
              xs={24}
              sm={singleColumn ? 24 : 12}
              md={singleColumn ? 24 : 8}
              lg={singleColumn ? 24 : 6}
              xl={singleColumn ? 24 : 6}
            >
              <Card
                hoverable
                onClick={() => setSelected(item.title)}
                style={{
                  textAlign: 'center',
                  borderRadius: 12,
                  height: '100%',
                  border: isActive ? '2px solid #1890ff' : '1px solid #f0f0f0',
                  boxShadow: isActive
                    ? '0 4px 12px rgba(24,144,255,0.2)'
                    : '0 2px 8px rgba(0,0,0,0.05)',
                  transition: 'all 0.3s',
                }}
              >
                <div style={{ marginBottom: 12 }}>
                  <IconComponent
                    style={{
                      fontSize: item.fontSize || 40,
                      color: isActive ? '#1890ff' : item.color,
                    }}
                  />
                </div>
                <h3 style={{ margin: 0, color: isActive ? '#1890ff' : 'inherit' }}>
                  {item.title}
                </h3>
              </Card>
            </Col>
          );
        })}
      </Row>

      {/* Selected component */}
      <div style={{ marginTop: 24 }}>
        {manageServices.find((item) => item.title === selected)?.compo}
      </div>
    </div>
  );
};

export default ManageServices;
